/* ---------------------------------------------------------------------------
   ws-nav-drawer.js — keep aria-expanded honest on the mobile menu

   The parent rows are real <button>s now, which gives keyboard operation for
   free, but a button that discloses something has to SAY whether it is open.
   assets/wixkraft.js drives the drawer by toggling a `specs-active` class and
   never touches aria, so a screen reader would have been told "collapsed"
   forever.

   Rather than race that script's click handler — ordering between two
   listeners on the same element is not something to rely on — this observes
   the class attribute and mirrors it. Whatever changes the class, by click,
   by keyboard, or by the theme editor, the attribute follows.

   Guarded and idempotent: assets/theme.js defines 96 custom elements and this
   file may be parsed more than once in the editor, so it is safe to run twice.
--------------------------------------------------------------------------- */
(() => {
  const SELECTOR = '.new_mg_menu_main .specs-accordion-header';
  if (window.wsNavAria) return;
  window.wsNavAria = true;

  const sync = (el) =>
    el.setAttribute('aria-expanded', el.classList.contains('specs-active') ? 'true' : 'false');

  const observe = (el) => {
    if (el.dataset.wsAria) return;
    el.dataset.wsAria = '1';
    sync(el);
    new MutationObserver(() => sync(el)).observe(el, {
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  const scan = () => document.querySelectorAll(SELECTOR).forEach(observe);

  scan();
  // The drawer's markup is re-rendered when a section reloads in the editor.
  document.addEventListener('shopify:section:load', scan);
})();

/* ---------------------------------------------------------------------------
   SEARCH FROM INSIDE THE MENU DRAWER — close the menu first.
   ---------------------------------------------------------------------------
   Both drawers are z-index 999. The MENU drawer is moved to <body> when it
   opens (assets/theme.js:1454-1457); the SEARCH drawer stays where the overlay
   group rendered it, which is earlier in the document. Equal z-index, so later
   DOM order wins and the menu paints OVER the search drawer.

   Measured: with both open, elementsFromPoint(195, 400) returns
   NAVIGATION-DRAWER, not the search drawer. Search was fully functional --
   focus landed in the input and predictive results came back -- but the
   shopper could not see any of it.

   The brief's target state is one overlay and one focus trap, so the menu
   closes rather than the search drawer being raised above it. Raising it was
   the alternative and was rejected: #search-drawer is shared with desktop, and
   a global z-index bump to fix a mobile-only stacking order is a wider change
   than the problem.

   DEFERRED BY ONE TICK, deliberately. The theme opens the search drawer from a
   listener delegated on document.body (assets/theme.js:1360), so this click
   still has to reach body. Closing the menu synchronously would move the
   trigger's own ancestor mid-dispatch and the search drawer would never open.
   The timeout lets the click finish bubbling first.
--------------------------------------------------------------------------- */
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('.ws-drawer-search');
    if (!trigger) return;

    var menu = document.getElementById('header-sidebar-menu');
    if (!menu || !menu.hasAttribute('open') || typeof menu.hide !== 'function') return;

    setTimeout(function () {
      menu.hide();
    }, 0);
  });
})();
